import AddFile from "../../../../../assets/images/fileManager/AddFile.svg";
import AddFile2 from "../../../../../assets/images/fileManager/AddFile2.svg";
import { ReactComponent as ArrowDown } from "../../../../../assets/images/icons/ArrowDown.svg";
import { ReactComponent as NewFolder } from "../../../../../assets/images/fileManager/NewFolder.svg";
import { ReactComponent as FolderUpload } from "../../../../../assets/images/fileManager/FolderUpload.svg";
import { ReactComponent as FileUpload } from "../../../../../assets/images/fileManager/FileUpload.svg";
import { ReactComponent as LinkUpload } from "../../../../../assets/images/fileManager/LinkUpload.svg";
import { ReactComponent as NewFolderBlack } from "../../../../../assets/images/fileManager/NewFolderBlack.svg";
import { ReactComponent as FileUploadBlack } from "../../../../../assets/images/fileManager/FileUploadBlack.svg";
import { ReactComponent as LinkUploadBlack } from "../../../../../assets/images/fileManager/LinkUploadBlack.svg";
import { ReactComponent as AddItem } from "../../../../../assets/images/fileManager/context/AddItem.svg";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { useRef, useState } from "react";
import {
    handleSetContextMenuStatus,
    handleSetDefaultSelectedItem,
    handleSetLinkUploadModalStatus,
    handleSetNewFolderModalStatus
} from "../../fileManager.actions";
import { NewUploadButtonProps } from "./newUploadButton.interface";
import Dialog from "../../../dialog/dialog.index";
import { checkQuota, handleSetFileUploadState, handleSetFolderUploadState } from "../../../../../scripts/upload";
import { getPathHash, isTouchScreen } from "../../../../../scripts/helpers";
import PATH from "../../../../../urls/path";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../../redux/hooks";
import { shallowEqual } from "react-redux";

export default function NewUploadButton({ className }: NewUploadButtonProps): JSX.Element {
    const fileInputRef = useRef<any>();
    const folderInputRef = useRef<any>();
    const location = useLocation();
    const navigate = useNavigate();
    const { audioItems } = useAppSelector(({ audioItems: { audioItems } }) => ({ audioItems }), shallowEqual);
    const [newUploadModalStatus, setNewUploadModalStatus] = useState(false);

    return (
        <section id="newUploadButton">
            <input
                type="file"
                className="hidden upload-input"
                ref={fileInputRef}
                multiple={true}
                onChange={(e) => {
                    if (e.target.files) {
                        const files = Array.prototype.slice.call(e.target.files);
                        if (location.pathname !== PATH.shared) {
                            checkQuota(
                                files.reduce((sum, item) => sum + item.size, 0),
                                files
                            ).then((status) => {
                                if (status) {
                                    handleSetDefaultSelectedItem([]);
                                    handleSetFileUploadState({
                                        files: files,
                                        hash: location.pathname === PATH.shared ? getPathHash() : undefined
                                    });
                                }
                            });
                        } else {
                            handleSetDefaultSelectedItem([]);
                            handleSetFileUploadState({
                                files: files,
                                hash: location.pathname === PATH.shared ? getPathHash() : undefined
                            });
                        }
                    }
                    handleSetContextMenuStatus(false);
                }}
            />
            <input
                type="file"
                className="hidden upload-input"
                ref={folderInputRef}
                multiple={true}
                // @ts-ignore
                directory="true"
                webkitdirectory="true"
                onChange={(e) => {
                    const files = Array.prototype.slice.call(e.target.files);
                    if (location.pathname !== PATH.shared) {
                        checkQuota(
                            files.reduce((sum, item) => sum + item.size, 0),
                            [],
                            files
                        ).then((status) => {
                            if (status) {
                                handleSetDefaultSelectedItem([]);
                                handleSetFolderUploadState({
                                    files: e.target.files as any,
                                    hash: location.pathname === PATH.shared ? getPathHash() : undefined
                                });
                            }
                        });
                    } else {
                        handleSetDefaultSelectedItem([]);
                        handleSetFolderUploadState({
                            files: e.target.files as any,
                            hash: location.pathname === PATH.shared ? getPathHash() : undefined
                        });
                    }
                    handleSetContextMenuStatus(false);
                }}
            />
            <Dialog status={newUploadModalStatus} onClose={() => setNewUploadModalStatus(false)} closeButton={false} closeOnBlur={true}>
                <div className="p-4">
                    <div
                        className="flex items-center gap-2 text-secondary-800 text-[14px] py-4"
                        onClick={() => {
                            setNewUploadModalStatus(false);
                            handleSetNewFolderModalStatus(true);
                        }}
                    >
                        <NewFolderBlack />
                        <span>پوشه جدید</span>
                    </div>
                    <div
                        className="flex items-center gap-2 text-secondary-800 text-[14px] py-4"
                        onClick={() => {
                            setNewUploadModalStatus(false);
                            fileInputRef.current.click();
                        }}
                    >
                        <FileUploadBlack />
                        <span>آپلود فایل</span>
                    </div>
                    <div
                        className="new-upload-link-mobile flex items-center gap-2 text-secondary-800 text-[14px] my-4"
                        onClick={() => {
                            setNewUploadModalStatus(false);
                            handleSetLinkUploadModalStatus(true);
                        }}
                    >
                        <LinkUploadBlack />
                        <span>آپلود از طریق لینک</span>
                    </div>
                </div>
            </Dialog>
            {!isTouchScreen() && (
                <div className={`new-upload`}>
                    <Menu
                        menuButton={
                            <div
                                id={"upload-menu-button"}
                                className="bg-primary-50 rounded-[10px] py-2 px-4 flex items-center gap-2 w-[215px] cursor-pointer justify-between"
                            >
                                <img src={AddFile2} className="rotate-[90deg]" alt="add file" />
                                <span className="text-primary-600 text-[14px]">افزودن فایل / پوشه</span>
                                <ArrowDown className="fill-primary-600" />
                            </div>
                        }
                        transition
                        menuClassName={
                            "!w-[215px] absolute z-50 bg-white !p-0 overflow-hidden !rounded-[5px] !shadow-none !select-none !bg-primary-50 mt-2"
                        }
                    >
                        <MenuItem
                            className="p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group"
                            // todo: prevent upload condition
                            // disabled={store.getState().fileManager.activePurchases ? store.getState().fileManager.activePurchases.userPlanStatus !== UserPlanStatus.normal : false}
                            onClick={() => handleSetNewFolderModalStatus(true)}
                        >
                            <NewFolder className="fill-secondary-500 group-hover:fill-primary-600 transition-all" width="20px" height="20px" />
                            <span className="text-secondary-800 text-[14px] font-bold group-hover:text-primary-600 transition-all">پوشه جدید</span>
                        </MenuItem>
                        <MenuItem
                            className="p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group"
                            // todo: prevent upload condition
                            // disabled={store.getState().fileManager.activePurchases ? store.getState().fileManager.activePurchases.userPlanStatus !== UserPlanStatus.normal : false}
                            onClick={() => folderInputRef.current.click()}
                        >
                            <FolderUpload className="fill-secondary-500 group-hover:fill-primary-600 transition-all" width="20px" height="20px" />
                            <span className="text-secondary-800 text-[14px] font-bold group-hover:text-primary-600 transition-all">آپلود پوشه</span>
                        </MenuItem>
                        <MenuItem
                            className="p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group"
                            // todo: prevent upload condition
                            // disabled={store.getState().fileManager.activePurchases ? store.getState().fileManager.activePurchases.userPlanStatus !== UserPlanStatus.normal : false}
                            onClick={() => fileInputRef.current.click()}
                        >
                            <FileUpload className="fill-secondary-500 group-hover:fill-primary-600 transition-all" width="20px" height="20px" />
                            <span className="text-secondary-800 text-[14px] font-bold group-hover:text-primary-600 transition-all">آپلود فایل</span>
                        </MenuItem>
                        <MenuItem
                            className="new-upload-link p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group"
                            // todo: prevent upload condition
                            // disabled={store.getState().fileManager.activePurchases ? store.getState().fileManager.activePurchases.userPlanStatus !== UserPlanStatus.normal : false}
                            onClick={() => handleSetLinkUploadModalStatus(true)}
                        >
                            <LinkUpload className="fill-secondary-500 group-hover:fill-primary-600 transition-all" width="20px" height="20px" />
                            <span className="text-secondary-800 text-[14px] font-bold group-hover:text-primary-600 transition-all">
                                آپلود از طریق لینک
                            </span>
                        </MenuItem>
                        {/* <MenuItem
                            className="p-4 hover:bg-gray-100 flex items-center gap-2 cursor-pointer transition-all group"
                            // todo: prevent upload condition
                            // disabled={store.getState().fileManager.activePurchases ? store.getState().fileManager.activePurchases.userPlanStatus !== UserPlanStatus.normal : false}
                            onClick={() => {
                                const qs = new URLSearchParams(window.location.search);
                                navigate(PATH.excelEditor(undefined, qs.get("path")!));
                            }}
                        >
                            <AddItem className="fill-secondary-500 group-hover:fill-primary-600 transition-all" width="20px" height="20px" />
                            <span className="text-secondary-800 text-[14px] font-bold group-hover:text-primary-600 transition-all">
                                ایجاد فایل اکسل جدید
                            </span>
                        </MenuItem> */}
                    </Menu>
                </div>
            )}
            {isTouchScreen() && (audioItems === undefined || (!!audioItems && audioItems.length === 0)) && (
                <span
                    onClick={() => {
                        // todo: prevent upload condition
                        // if (store.getState().fileManager.activePurchases && store.getState().fileManager.activePurchases.userPlanStatus !== UserPlanStatus.danger) setNewUploadModalStatus(true)
                        setNewUploadModalStatus(true);
                    }}
                    id={"upload-link-url-mobile"}
                    className={`new-upload-mobile fixed bottom-4 left-4 sm:left-[80px] z-[9] sm:z-[10] ${className}`}
                >
                    <img src={AddFile} alt="add file" />
                </span>
            )}
        </section>
    );
}
